export default function COUNT() {
  return <div>Excel_COUNT</div>;
}
